import React from 'react';
import { withSunnyPage } from '@/components/Common/SunnyPage';
import SunnyLayout from '@/components/Common/SunnyLayout/SunnyLayout';
import PageTitle from '@/components/Common/PageTitle/PageTitle';
import styles from './contents-law.module.scss';
import { getSVG } from '@/components/Common/styles/mixins';
import { getYaNative } from '@yanolja-org/ya-native';
import { SunnyFC } from '@/components/Common/SunnyNext';

const ContentsLaw: SunnyFC = () => {
  const onClickClose = () => {
    const yaNative = getYaNative();

    if (yaNative.isEnabled) {
      yaNative.dismiss();
    } else {
      window.close();
    }
  };

  return (
    <SunnyLayout className={styles.body}>
      {{
        header: (
          <PageTitle left="close" onClickLeft={onClickClose} className={styles.contentsLawStyle}>
            콘텐츠산업 진흥법에 따른 표시
          </PageTitle>
        ),
        body: (
          <div className={styles.bodyContent}>
            <div className={styles.image}>
              <img
                src={getSVG('/static/images/icon-contents-caution.png')}
                alt="콘텐츠 산업 진흥법에 따른 표시 이미지"
              />
            </div>
            <h2 className={styles.title}>콘텐츠의 종류</h2>
            <p className={styles.text}>상품/판매자/이벤트 정보, 디자인 및 화면의 구성, UI</p>
            <div className={styles.divider} />
            <h2 className={styles.title}>제작연월일</h2>
            <p className={styles.text}>개별콘텐츠의 개시일 또는 갱신일제작자</p>
            <div className={styles.divider} />
            <h2 className={styles.title}>제작자</h2>
            <p className={styles.text}>(주)놀유니버스 및 개별판매자</p>
            <div className={styles.divider} />
            <p className={styles.footer}>
              (주)놀유니버스 사이트 상의 콘텐츠는 &lsquo;콘텐츠산업 진흥법&rsquo;에 따라 개시일 또는 갱신일로부터 5년간
              보호됩니다.
            </p>
          </div>
        ),
      }}
    </SunnyLayout>
  );
};

export default withSunnyPage()(ContentsLaw);
